// Date example
import { NumberDecoder } from "@simonbackx/simple-encoding";
import { Filter, FilterDefinition } from "./FilterDefinition";
export class NumberFilterDefinition extends FilterDefinition {
    constructor(settings) {
        super(settings);
        this.floatingPoint = false;
        this.currency = false;
        if (settings.floatingPoint !== undefined) {
            this.floatingPoint = settings.floatingPoint;
        }
        if (settings.currency !== undefined) {
            this.currency = settings.currency;
        }
    }
    decode(data) {
        var _a, _b, _c, _d, _e, _f;
        const filter = this.createFilter();
        filter.start = (_b = (_a = data.optionalField("start")) === null || _a === void 0 ? void 0 : _a.nullable(NumberDecoder)) !== null && _b !== void 0 ? _b : null;
        filter.end = (_d = (_c = data.optionalField("end")) === null || _c === void 0 ? void 0 : _c.nullable(NumberDecoder)) !== null && _d !== void 0 ? _d : null;
        filter.mode = (_f = (_e = data.optionalField("mode")) === null || _e === void 0 ? void 0 : _e.enum(NumberFilterMode)) !== null && _f !== void 0 ? _f : NumberFilterMode.Equal;
        return filter;
    }
    createFilter() {
        const filter = new NumberFilter();
        filter.definition = this;
        return filter;
    }
}
export var NumberFilterMode;
(function (NumberFilterMode) {
    NumberFilterMode["GreaterThan"] = "GreaterThan";
    NumberFilterMode["LessThan"] = "LessThan";
    NumberFilterMode["Between"] = "Between";
    NumberFilterMode["NotBetween"] = "NotBetween";
    NumberFilterMode["Equal"] = "Equal";
    NumberFilterMode["NotEqual"] = "NotEqual";
})(NumberFilterMode || (NumberFilterMode = {}));
export class NumberFilter extends Filter {
    constructor() {
        super(...arguments);
        this.start = null;
        this.end = null;
        this.mode = NumberFilterMode.Equal;
    }
    doesMatch(object) {
        const num = this.definition.getValue(object);
        if (this.mode === NumberFilterMode.LessThan) {
            if (this.end === null) {
                return true;
            }
            return num <= this.end;
        }
        if (this.mode === NumberFilterMode.GreaterThan) {
            if (this.start === null) {
                return true;
            }
            return num >= this.start;
        }
        if (this.mode === NumberFilterMode.Between) {
            if (this.start === null) {
                if (this.end === null) {
                    return true;
                }
                return num <= this.end;
            }
            if (this.end === null) {
                return num >= this.start;
            }
            return num >= this.start && num <= this.end;
        }
        if (this.mode === NumberFilterMode.NotBetween) {
            if (this.start === null) {
                if (this.end === null) {
                    return false;
                }
                return num > this.end;
            }
            if (this.end === null) {
                return num < this.start;
            }
            return !(num >= this.start && num <= this.end);
        }
        if (this.mode === NumberFilterMode.NotEqual) {
            return num !== this.start;
        }
        return num === this.start;
    }
    encode(context) {
        return {
            definitionId: this.definition.id,
            start: this.start === null ? undefined : this.start,
            end: this.end === null ? undefined : this.end,
            mode: this.mode
        };
    }
    toString() {
        if (this.definition.explainFilter) {
            return this.definition.explainFilter(this);
        }
        if (this.mode === NumberFilterMode.GreaterThan) {
            return this.definition.name + " is " + this.start + " of meer";
        }
        if (this.mode === NumberFilterMode.LessThan) {
            return this.definition.name + " is " + this.end + " of minder";
        }
        if (this.mode === NumberFilterMode.Between) {
            if (this.start === null) {
                if (this.end === null) {
                    return this.definition.name + " is gelijk wat";
                }
                return this.definition.name + " is " + this.end + " of minder";
            }
            if (this.end === null) {
                return this.definition.name + " is " + this.start + " of meer";
            }
            return this.definition.name + " tussen " + this.start + " en " + this.end;
        }
        if (this.mode === NumberFilterMode.NotBetween) {
            if (this.start === null) {
                if (this.end === null) {
                    return "nooit";
                }
                return this.definition.name + " is groter dan " + this.end;
            }
            if (this.end === null) {
                return this.definition.name + " is kleiner dan " + this.start;
            }
            return this.definition.name + " niet tussen " + this.start + " en " + this.end;
        }
        if (this.mode === NumberFilterMode.NotEqual) {
            return this.definition.name + " is niet gelijk aan " + this.start;
        }
        if (this.mode === NumberFilterMode.Equal) {
            return this.definition.name + " is gelijk aan " + this.start;
        }
        return "Onbekend";
    }
    get inverted() {
        const filter = this.clone();
        if (filter.mode === NumberFilterMode.GreaterThan) {
            filter.mode = NumberFilterMode.LessThan;
        }
        else if (filter.mode === NumberFilterMode.LessThan) {
            filter.mode = NumberFilterMode.GreaterThan;
        }
        else if (filter.mode === NumberFilterMode.Between) {
            filter.mode = NumberFilterMode.NotBetween;
        }
        else if (filter.mode === NumberFilterMode.NotBetween) {
            filter.mode = NumberFilterMode.Between;
        }
        else if (filter.mode === NumberFilterMode.NotEqual) {
            filter.mode = NumberFilterMode.Equal;
        }
        else if (filter.mode === NumberFilterMode.Equal) {
            filter.mode = NumberFilterMode.NotEqual;
        }
        return filter;
    }
}
//# sourceMappingURL=NumberFilter.js.map